<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.details" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="showDetails" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.selectionTypeLabel" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="selectionTypeLabel" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.toggleSelectionBtn" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="toggleSelectionBtn" /><!--
          --><checkbox label-size="xs" :disabled="expanded" :icon-color="$root.$colors.primary" :label="$lang.icon" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="icon" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.expanded" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="expanded" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.dense" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="dense" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="8" v-for="(count, index) in lists" :key="index">
        <card full-height :overflow-off="false" md12 sm24>
          <card-title :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white">Items length: {{ count }}</card-title>
          <card-text>
            <clustered-list
              multiple
              @apply="onApply"
              :name="`numbers-${count}`"
              use-worker
              :color="$root.$colors.primary"
              :color-lightness="$root.$colors.bgColorLightness"
              :icon="icon ? 'view-dashboard' : null"
              :dense="dense"
              :expanded="expanded"
              :resource="items(count)"
              :disabled="disabled"
              :show-details="showDetails"
              :show-selection-type-label="selectionTypeLabel"
              :toggle-selection-btn="toggleSelectionBtn"
              :searchable="searchable"
              :fuzzy-search="fuzzySearch"
              :visible-items="items(count).length <= 5 ? items(count).length : 5"
              :default-selection="[1, 2, 3, 5, 10, 100, 1000]"
              :label="`Clustered list with ${count} items`.toUpperCase()" />
          </card-text>
        </card>
      </flex-col>
      <flex-col :span="24">
        <md-section :class="['mt-4']" md="clustered-list-installation.md" />
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageClusteredList',
  mixins: [
    methods
  ],
  data () {
    return {
      expanded: false,
      disabled: false,
      showDetails: true,
      searchable: true,
      toggleSelectionBtn: true,
      fuzzySearch: false,
      defaultSelection: 'all',
      icon: true,
      dense: false,
      selectionTypeLabel: true,
      lists: Array.from(Array(6).keys()).map(value => {
        return (value + 1) * 5000
      })
    }
  },
  methods: {
    onApply ($event) {
      this.log('apply', 'clustered-list', $event)
    },
    items (count) {
      return Array.from(Array(count).keys()).map(value => {
        value = value + 1
        return {
          value: value,
          text: `${value} of ${count}`
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/forms/clustered-list.vue